"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatePreview = void 0;
const react_1 = __importDefault(require("react"));
const react_components_1 = require("@cimpress/react-components");
const react_fast_highlight_1 = require("react-fast-highlight");
const juice_1 = __importDefault(require("juice"));
const file_saver_1 = require("file-saver");
const i18n_1 = require("../i18n");
const Loading_1 = require("../internal/Loading");
const useMaterialization_1 = require("../hooks/useMaterialization");
const errorComponent_1 = require("./errorComponent");
const constants_1 = require("../constants");
const pdfViewer_1 = require("./pdfViewer");
exports.TemplatePreview = ({ enforceHtmlProcessor, renderContainer, accessToken, templateUrl, withButtons, crawlingOptions, language, payload }) => {
    const shouldProducePdfOutput = renderContainer === 'pdf';
    const { materializationText, materializationBlob, fetchingError, fetching, templateType, contentType } = useMaterialization_1.materialize(enforceHtmlProcessor, shouldProducePdfOutput, accessToken, templateUrl, payload, crawlingOptions);
    const t = i18n_1.getI18nInstance().getFixedT(language);
    if (fetching) {
        return react_1.default.createElement(Loading_1.Loading, { message: t('loading') });
    }
    const getPreviewContent = () => {
        if (constants_1.edieTemplateTypes.includes(templateType)) {
            const styledHtml = juice_1.default(materializationText);
            const extractedContent = (/<body[^>]*>((.|[\n\r])*)<\/body>/).exec(styledHtml);
            if ((extractedContent === null || extractedContent === void 0 ? void 0 : extractedContent.length) > 0)
                return extractedContent[1];
        }
        return materializationText;
    };
    const renderPreview = () => {
        // An exception
        if ([constants_1.contentTypes.xlsx].some(ct => contentType.includes(ct))) {
            return t('contentNotSupported');
        }
        switch (renderContainer) {
            case "none":
                return materializationText;
            case "htmlDiv":
                return renderContentInHtmlDiv(getPreviewContent(), 'template-preview-container');
            case "pdf":
            case "auto":
                if (contentType.includes(constants_1.contentTypes.pdf)) {
                    return react_1.default.createElement(pdfViewer_1.PdfViewer, { pdf: URL.createObjectURL(materializationBlob) });
                }
            // eslint-disable-next-line no-fallthrough
            default:
                return react_1.default.createElement(react_fast_highlight_1.Highlight, { languages: ['html', 'xml', 'json', 'xlsx', 'excel', 'xls'] }, materializationText || '');
        }
    };
    const getDownloadButton = (btnConfig) => {
        const blobData = new Blob([materializationBlob], {
            type: contentType
        });
        return react_1.default.createElement(react_components_1.Button, { style: { alignSelf: btnConfig.position === 'topLeft' ? 'flex-start' : 'flex-end' }, onClick: () => {
                file_saver_1.saveAs(blobData, (btnConfig === null || btnConfig === void 0 ? void 0 : btnConfig.filename) || 'output');
            } }, t('download'));
    };
    const getButton = (btn, btnConfig) => {
        switch (btn) {
            case 'download':
                return getDownloadButton(btnConfig);
            default:
                return '';
        }
    };
    return fetchingError
        ? react_1.default.createElement(errorComponent_1.ErrorComponent, { error: fetchingError, t: t })
        : react_1.default.createElement(react_1.default.Fragment, null,
            Object.keys(withButtons || {}).length > 0 && react_1.default.createElement("div", { style: { marginBottom: '10px', display: 'flex', flexDirection: 'column' } }, Object.entries(withButtons).map((([key, value]) => getButton(key, value)))),
            renderPreview());
};
const renderContentInHtmlDiv = (content, className) => react_1.default.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: content }, onClick: (e) => {
        let target = e.target;
        while (target) {
            if (target.tagName && target.tagName.toLowerCase() === 'a') {
                target.setAttribute('target', '_blank');
                return;
            }
            target = target.parentNode;
        }
    } });
//# sourceMappingURL=TemplatePreview.js.map